import { isNetquestClient, isPureProfileClient } from '../../../utils/clients';

export enum UserTypes {
  SxAdmin = 'SX_ADMIN',
  MainAdmin = 'MAIN_ADMIN',
  AccountAdmin = 'ACCOUNT_ADMIN',
  TeamAdmin = 'TEAM_ADMIN',
  AdminAssistant = 'ADMIN_ASSISTANT',
  User = 'USER',
  Prospect = 'PROSPECT',
}

export type Weights = Record<UserTypes, number>

export const UserTypesWeights: Weights = {
  [UserTypes.SxAdmin]: 0,
  [UserTypes.MainAdmin]: 1,
  [UserTypes.AdminAssistant]: 2,
  [UserTypes.AccountAdmin]: 3,
  [UserTypes.TeamAdmin]: 4,
  [UserTypes.User]: 5,
  [UserTypes.Prospect]: 5
};

export const UserTypeMap = new Map<UserTypes, string>([
  [UserTypes.SxAdmin, 'SightX Admin'],
  [UserTypes.MainAdmin, 'Admin'],
  [UserTypes.AccountAdmin, 'Account Admin'],
  [UserTypes.AdminAssistant, 'Admin Assistant'],
  [UserTypes.AccountAdmin, 'Account Admin'],
  [UserTypes.User, 'User']
]);

export const UserTypeMapForPlgExternal = new Map<UserTypes, string>([
  [UserTypes.SxAdmin, 'SightX Admin']
]);

if (isNetquestClient() || isPureProfileClient()) {
  UserTypeMapForPlgExternal.set(UserTypes.MainAdmin, 'Admin');
  UserTypeMapForPlgExternal.set(UserTypes.AdminAssistant, 'Admin Assistant');
}

UserTypeMapForPlgExternal.set(UserTypes.AccountAdmin, 'Account Admin');
UserTypeMapForPlgExternal.set(UserTypes.User, 'User');

export const USER_TYPES = [
  { value: UserTypes.SxAdmin, label: 'SightX Admin', displayOrder: 1 },
  { value: UserTypes.AccountAdmin, label: 'Account Admin', displayOrder: 2 },
  { value: UserTypes.TeamAdmin, label: 'Team Admin', displayOrder: 3 },
  { value: UserTypes.User, label: 'User', displayOrder: 4 }
];
